import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=95d741f4&"
import script from "./SubscriptionList.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionList.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VSkeletonLoader,VTooltip})
